export default [
  {
    path: '/admin/v2/stock-in',
    name: 'stock-in-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-in-v2/index.vue')
  },
  {
    path: '/admin/v2/stock-in/create',
    name: 'stock-in-create-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-in-v2/create.vue')
  },
  {
    path: '/admin/v2/stock-in/:id/edit',
    name: 'stock-in-edit-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-in-v2/edit.vue')
  }
]
